import { render, staticRenderFns } from "./StepTeachers.vue?vue&type=template&id=5176cd9c&scoped=true&"
import script from "./StepTeachers.vue?vue&type=script&lang=js&"
export * from "./StepTeachers.vue?vue&type=script&lang=js&"
import style0 from "./StepTeachers.vue?vue&type=style&index=0&id=5176cd9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176cd9c",
  null
  
)

export default component.exports